// extracted by mini-css-extract-plugin
module.exports = {"whatsapp_action":"ListingPage_whatsapp_action__1CLA8"};